query allMarketDisplayConfigurations(
  $sportId: UUID
  ) {
  allMarketDisplayConfigurations(
    condition: {
        sportId: $sportId
    }
  ) {
    nodes {
      groupView
      active
      marketCode
      defaultName
      parameters
      position
      selections
      shortNamePattern
      longNamePattern
      grouped
      sportId
    }
  }
}
